export const censorString = (value: string): string =>
  value?.length <= 4
    ? '****'
    : value.split('').reduce((accumulated, current, index) => {
        return index <= 1 || index >= value.length - 2 ? accumulated + current : `${accumulated}*`
      }, '')
